import { ApiListResponse, ApiObjectResponse, RootType } from '../../internal';
import { getRoot, types } from 'mobx-state-tree';
import { HttpVerbs } from '../../constants/verbs';

const PAGE_SIZE = 20;

export type RecommendedBrandsApiType = {
  id: number | string;
  partnerId: string;
  name: string;
};
export const RecommendedBrandsApi = types
  .model('RecommendedPartnersApi', {})
  .views((self) => ({
    get root(): RootType {
      return getRoot(self);
    },
  }))
  .actions((self) => {
    return {
      async savePartners(partners: string[]) {
        try {
          const data = {
            partners,
          };
          return await self.root.axios.requestData({
            type: HttpVerbs.POST,
            path: '/partners/favorites',
            data,
          });
        } catch (err) {
          self.root.showFailure('e400');
          throw err;
        }
      },

      async getList(): Promise<ApiListResponse<RecommendedBrandsApiType>> {
        return await self.root.axios.requestData({
          type: HttpVerbs.GET,
          path: '/partners/favorites',
        });
      },
    };
  });
